/* eslint-disable no-unused-vars */
import { memo, useMemo } from 'react';
import { Typography, Stack } from '@mui/material';
import { CustomInput, CustomInputAutosize } from 'components';
import * as S from '../../ConversionTracking.styled';
import uuid from 'react-uuid';

const titleText = {
  Deep_Link: 'Final Deep Link URL:',
  Tracking_Link: 'Final Click URL:',
  Impression_Link: 'Final Impression URL:',
  VTA_Link: 'Final Impression URL:',
};

const FinalUrl = ({ field, link }) => {
  const rowsNumber = useMemo(() => Math.ceil(link ? link.length / 120 + 2 : 3), [link]);

  return (
    <Stack sx={{ marginBottom: '32px' }}>
      <Stack direction='row' sx={{ justifyContent: 'space-between', marginBottom: '8px' }}>
        <Typography key='Deep_Link' style={S.TitleLabels}>
          {titleText[field]}
        </Typography>

        {(field === 'Deep_Link' || field === 'Tracking_Link') && (
          <Stack direction='row'>
            <Typography style={S.RequirementsLabels}>
              Preview your postback URL and save it.
            </Typography>
          </Stack>
        )}
      </Stack>
      <CustomInputAutosize
        readOnly
        id={`FinalUrl_${field}_${uuid()}`}
        name={`FinalUrl_${field}_${uuid()}`}
        value={link || ''}
      />
      {/* <CustomInput
        multiline
        readOnly
        rows={rowsNumber < 9 ? rowsNumber : 9}
        id={`FinalUrl_${field}_${uuid()}`}
        name={`FinalUrl_${field}_${uuid()}`}
        value={link || ''}
      /> */}
    </Stack>
  );
};

export default memo(FinalUrl);
